module.exports = __webpack_public_path__ + "img/Rotterdam.b9810a7a.png";